import React from 'react';
import { Settings, Wrench, RefreshCw, Zap, Flame, Cog, Plug, Radio } from 'lucide-react';
import { services } from '../mock';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';

const iconMap = {
  Settings: Settings,
  Wrench: Wrench,
  RefreshCw: RefreshCw,
  Zap: Zap,
  Flame: Flame,
  Cog: Cog,
  Plug: Plug,
  Radio: Radio
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Our <span className="text-blue-600">Services</span>
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Comprehensive power plant solutions for units up to 500 MW capacity
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-blue-600 cursor-pointer"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-600 transition-colors duration-300">
                    <Icon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl mb-2 group-hover:text-blue-600 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-slate-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-slate-50 rounded-xl p-8 border border-slate-200">
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">500 MW</div>
              <p className="text-slate-600">Maximum Unit Capacity</p>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">18+</div>
              <p className="text-slate-600">Major Clients</p>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">100%</div>
              <p className="text-slate-600">Project Success Rate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
